import React from 'react'

import { Header } from '@masfront/common-b2c'

import useSalesHeader from './useSalesHeader'

import useLogout from '~/auth/hooks/useLogout'
import useTheme from '~/ui/theme/useTheme'

export default function SalesHeader() {
  const { agentName, onSelectModalMessage } = useSalesHeader()
  const logout = useLogout()
  const { theme } = useTheme()

  return (
    <Header
      onHandleLogout={logout}
      onChangeBrand={(brandToChange) => onSelectModalMessage('CHANGE_BRAND', brandToChange)}
      theme={theme.name}
      title="MasClientes"
      agentName={agentName}
    />
  )
}
